import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class MarketSelectorService {
  currentSelectedOption: Observable<number>;
  private selectionState = new BehaviorSubject<number>(1);

  constructor() {
    this.currentSelectedOption = this.selectionState.asObservable();
  }

  changeOption(option: number) {
    this.selectionState.next(option);
  }
}
